import * as React from 'react';
import { Alert, Button } from 'ui';
import styles from './notification-alert.module.css';

export interface NotificationAlertProps {
    title: string;
    installerReleaseNotesUrl: string | undefined;
    primaryButtonText: string;
    secondaryButtonText: string;
    primaryButtonAction?: () => void;
    secondaryButtonAction?: () => void;
    closeButtonAction?: () => void;
}

export const NotificationAlert: React.FC<NotificationAlertProps> = React.forwardRef<
    HTMLDivElement | null,
    NotificationAlertProps
>(function NotificationAlert(props, ref) {
    const {
        title,
        installerReleaseNotesUrl,
        primaryButtonText,
        secondaryButtonText,
        primaryButtonAction,
        secondaryButtonAction,
        closeButtonAction,
    } = props;

    return (
        <div ref={ref} data-testid="notification-alert">
            <Alert
                variant="info"
                title={title}
                onDismiss={closeButtonAction}
                extraContent={
                    <div className={styles['actions']}>
                        {installerReleaseNotesUrl ? (
                            <Button
                                className={styles['secondary-button']}
                                size="sm"
                                color="ghost"
                                label={secondaryButtonText}
                                onClick={secondaryButtonAction}
                            />
                        ) : null}
                        <Button
                            className={styles['primary-button']}
                            size="sm"
                            color="primary"
                            label={primaryButtonText}
                            onClick={primaryButtonAction}
                        />
                    </div>
                }
            />
        </div>
    );
});
